// Styles & fonts
import '@sass/main.scss';
import {loadFonts} from '@assets/js/utilities/fontsLoader.js';
import 'virtual:vite-svg-2-webfont.css';

// Dynamically import all JS files from drop-ins and components
import.meta.glob('@assets/js/drop-in/**/*.js', {eager: true});
import.meta.glob('../../components/**/*.js', {eager: true});

loadFonts({
    fontFiles: import.meta.glob('@assets/fonts/*.woff2', {eager: true}),
    publicPath: '/content/themes/master/assets/fonts/',
    unicodeRange: 'U+000-5FF, U+0100-017F'
});

// Optional app initialization if window.app.init() exists
if (typeof window.app !== 'undefined' && typeof window.app.init === 'function') {
    jQuery(function () {
        window.app.init();
    });
}
